import {Observable} from 'rxjs';
import {combineEpics} from 'redux-observable';
import {
  loadingStop,
  LOADING_START,
  SEND_DETAILS,
  SEND_DETAILS_FAIL,
  SEND_DETAILS_SUCCESS,
  sendDetailsSuccess,
  sendDetailsFail,
  switchApplyPopup,
  APPLY_TEAMMATES_FIELD,
  nextApplyStep,
  removeErrorAction,
  CHECK_EMAILS,
  CHECK_EMAILS_SUCCESS,
  checkEmailsSuccess,
  checkEmailsFail,
  CHECK_TEAM,
  CHECK_TEAM_SUCCESS,
  checkTeamSuccess,
  applyTeammatesField
} from "../actions";
// const api_url = 'http://localhost:8080/api/';
// const api_url = 'https://adidas-testing.herokuapp.com/api/';
const api_url = 'https://adidas-server.herokuapp.com/api/';
function loadingEpic(action$) {
  return action$.ofType(LOADING_START)
    .switchMap(() => {
      return Observable.of(loadingStop()).delay(2000);
    });
}

function parseDetails(details){
  let keys = Object.keys(details);
  let tempDetails = {};
  let otherKeys = [];
  keys.forEach((key) => {
    if(key.indexOf('_other') === -1){
      tempDetails[key] = details[key];
    }else{
      otherKeys.push(key);
    }
  });
  otherKeys.forEach((okey) => {
    let initalKey = okey.replace('_other', '');
    tempDetails[initalKey] = details[okey];
  })
  console.log(tempDetails);
  return tempDetails;
}

function sendDetailsEpic(action$) {
  return action$.ofType(SEND_DETAILS)
  .switchMap((action) =>{
    return Observable.ajax({
      url: `${api_url}register/new`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(parseDetails(action.details))
    })
    .map(response => sendDetailsSuccess(response.response))
    .catch(err => {
      console.log("Stuff man::", err);
      return Observable.of(sendDetailsFail(err.response))
    })
  })
}

function closeModalEpic(action$) {
  return action$.ofType(SEND_DETAILS_SUCCESS)
  .switchMap(() => {
    return Observable.of(switchApplyPopup(false))
  })
}

function goNextAfterApplyTeammates(action$) {
  return action$.ofType(APPLY_TEAMMATES_FIELD)
  .switchMap(() => {
    return Observable.of(nextApplyStep());
  });
}

function removeError(action$) {
  return action$.ofType(SEND_DETAILS_FAIL)
  .switchMap(() => {
    return Observable.of(removeErrorAction()).delay(5000);
  });
}

function checkEmailsEpic(action$) {
  return action$.ofType(CHECK_EMAILS)
  .switchMap((action) => {
    return Observable.ajax({
      url: `${api_url}register/email/check`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({emails: action.emails})
    })
    .map(response => checkEmailsSuccess(response.response))
    .catch(err => {
      return Observable.of(checkEmailsFail(err.response))
    })
    // return Observable.of(checkEmailsSuccess(action.emails));
  })
}

function emailsSuccess(action$) {
  return action$.ofType(CHECK_EMAILS_SUCCESS)
  .switchMap((action) => {
    // console.log(Object.keys(action.emails));
    let emails = Object.keys(action.emails).filter((mail) => {
      return action.emails[mail];
    })
    if(emails.length){
      let errorData = `${emails.join(', ')} ${emails.length > 1 ? 'are' : 'is'} already registered`
      return Observable.of(sendDetailsFail({error: errorData}));
    }else{
      return Observable.of(nextApplyStep());
    }

  })
}

function teamNameCheck(action$) {
  return action$.ofType(CHECK_TEAM)
  .switchMap((action) => {
    return Observable.ajax({
      url: `${api_url}register/team/check`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({name: action.name})
    })
    .map(response => checkTeamSuccess(response.response))
    .catch(err => {
      console.log(err);
      return Observable.of(loadingStop()).delay(2000);
    })
  })
}

function teamCheckSuccess(action$) {
  return action$.ofType(CHECK_TEAM_SUCCESS)
  .switchMap((action) => {
    if(action.exists){
      return Observable.of(sendDetailsFail({error: 'This name is already taken.'}))
    }else{
      return Observable.of(applyTeammatesField(true));
    }
  })
}


export const rootEpic = combineEpics(
  loadingEpic,
  sendDetailsEpic,
  closeModalEpic,
  goNextAfterApplyTeammates,
  removeError,
  checkEmailsEpic,
  emailsSuccess,
  teamNameCheck,
  teamCheckSuccess
);



// WEBPACK FOOTER //
// ./src/epics/index.js